<template>
  <a-modal
    :visible="visible"
    title="重置密码"
    @ok="handleOk"
    @cancel="onClose"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item label="新密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-password
          v-decorator="['pwd']"
          placeholder="不填默认为123456"
        ></a-input-password>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { resetPassWord } from "@/api/system/user";
export default {
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 5 }, sm: { span: 7 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 17 } },
      loading: false,
      id: "",
      tempPwd: ""
    };
  },
  methods: {
    showModal(id) {
      this.id = id;
      this.visible = true;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        this.loading = true;
        if (!err) {
          let params = Object.assign({ userId: this.id }, values);
          resetPassWord({ ...params }).then(res => {
            if (res.resultCode === 1) {
              this.$notification.success({
                message: res.message
              });
            } else {
              this.$notification.error({
                message: res.message
              });
            }
            this.loading = false;
            this.onClose();
          });
        }
      });
    },
    onClose() {
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>

<style></style>
